require('./ctxWeeklyScheduler.style.scss');
const FULL_INCREMENTAL_MODE = 'FULL_INCREMENTAL_MODE',
    INCR_MODE = 'INCR_MODE';
class ctxWeeklySchedulerController {
    constructor($scope, $element, $timeout, $attrs, $filter, utilsService, dialogService) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$attrs = $attrs;
        this.$filter = $filter;
        this.utilsService = utilsService;
        this.dialogService = dialogService;
    }

    $onInit() {
        this.basePrepare();
        let unwatch = this.$scope.$watch(() => this.selectedHours, selected => {
            if (!selected || !selected.length) return;
            this.setTags(this.selectedHours);
            let editItems = selected.filter(sel => angular.isDefined(sel.raw));
            if (editItems.length === 0) {
                this.setSelectedItems();
            }
            this.setSelectedItems();
            unwatch();
        });
        let incrItems = this.selectedHours.filter(sel => sel.incrementalWindowSpecific);
        this.backupType = incrItems.length > 0 ? INCR_MODE : FULL_INCREMENTAL_MODE;
        this.$scope.$watch(() => this.tzChanged, (newTzChanged, oldTzChanged) => {
            if (newTzChanged !== oldTzChanged) {
                this.setSelectedItems();
                this.selectedHours = this.updateSelectedHours();
                this.setTags(this.selectedHours);
            }
        });

    }

    basePrepare() {
        this.selectedHours = this.selectedHours || [];
        this.days = this.days || [{ label: 'mon', value: 'MONDAY' }, { label: 'tue', value: 'TUESDAY' }, { label: 'wed', value: 'WEDNESDAY' }, { label: 'thu', value: 'THURSDAY' }, { label: 'fri', value: 'FRIDAY' }, { label: 'sat', value: 'SATURDAY' }, { label: 'sun', value: 'SUNDAY' }];
        this.hoursParsed = this.getBaseHours(this.hours);
        this.slidePosition = { index: 0, offset: 0 };
        this.tags = [];
        this.items = [];
        this.displayedTags = [];
        this.tagsPagination = { currentPage: 1, totalPages: 1 };
        this.days.forEach((d, i) => {
            let temp = { value: i, label: d.label, dayOfWeek: d.value, hours: [] };
            this.hoursParsed.forEach((h) => {
                temp.hours.push({ value: h.value, label: h.label, selected: false, preSelected: false, halfSelected: { start: false, end: false }, incrementalWindowSpecific: null })
            });
            this.items.push(temp)
        });

        this.setDefaultValues();

        this.daySorter = {};
        this.days.forEach((day, index) => {
            this.daySorter[day.value.toUpperCase()] = index
        });
        this.showHover = false;
    }

    setFullBw(item) {
        if (this.backupType === FULL_INCREMENTAL_MODE) return item.incrementalWindowSpecific = false;
        if (!item.selected && !item.preSelected) {
            return item.incrementalWindowSpecific = undefined;
        }
        return item.incrementalWindowSpecific = this.backupType === INCR_MODE;
    }

    onMouseEnterFn(event, hour, item) {
        event.stopPropagation();

        this.hoursMatrix.stopX = hour.value;
        this.hoursMatrix.stopY = item.value;

        this.hoursMatrix.maxX = Math.max(this.hoursMatrix.startX, this.hoursMatrix.stopX, this.hoursMatrix.maxX);
        this.hoursMatrix.minX = Math.min(this.hoursMatrix.startX, this.hoursMatrix.stopX, this.hoursMatrix.minX);
        this.hoursMatrix.maxY = Math.max(this.hoursMatrix.startY, this.hoursMatrix.stopY, this.hoursMatrix.maxY);
        this.hoursMatrix.minY = Math.min(this.hoursMatrix.startY, this.hoursMatrix.stopY, this.hoursMatrix.minY);

        for (let i = this.hoursMatrix.minY; i < this.hoursMatrix.maxY + 1; i++) {
            for (let j = this.hoursMatrix.minX; j < this.hoursMatrix.maxX + 1; j = j + 30) {
                if (this.items[i].hours[j / 30].selected) {
                    this.items[i].hours[j / 30].selected = !this.devarionMode;
                    this.setFullBw(this.items[i].hours[j / 30]);
                } else {
                    this.items[i].hours[j / 30].preSelected = this.outOfAxisSelection(this.hoursMatrix.startX, this.hoursMatrix.stopX, this.items[i].hours[j / 30].value) || this.outOfAxisSelection(this.hoursMatrix.startY, this.hoursMatrix.stopY, i) ? false : !this.devarionMode;
                    this.setFullBw(this.items[i].hours[j / 30]);
                }
                if (this.items[i].hours[j / 30].halfSelected.start) {
                    this.items[i].hours[j / 30].halfSelected.start = false;
                }
                if (this.items[i].hours[j / 30].halfSelected.end) {
                    this.items[i].hours[j / 30].halfSelected.end = false;
                }
            }
        }

        if (this.selectedDays.indexOf(item) < 0) this.selectedDays.push(item);
        this.calculateLinesOnDragg();
    }

    outOfAxisSelection(start, stop, value) {
        return start < stop ? (value < start || value > stop) : start > stop ? (value < stop || value > start) : value !== start;
    }

    onMouseDownFn(event, hour, item) {
        event.stopPropagation();
        this.mousedown = true;
        this.selectedDays.push(item);
        if (hour.selected) {
            this.devarionMode = true;
            hour.selected = !hour.selected;
            this.showHover = true;
            hour.halfSelected.start = false;
            hour.halfSelected.end = false;
        } else {
            hour.preSelected = !hour.preSelected;
            this.showHover = false;
        }
        this.setFullBw(hour);

        this.hoursMatrix.startX = this.hoursMatrix.stopX = this.hoursMatrix.maxX = this.hoursMatrix.minX = hour.value;
        this.hoursMatrix.startY = this.hoursMatrix.stopY = this.hoursMatrix.maxY = this.hoursMatrix.minY = item.value;
    }

    onMouseUpFn(event) {
        event.stopPropagation();
        this.switchToSelected();
        this.selectedHours = this.updateSelectedHours();
        this.setTags(this.selectedHours);
        this.setDefaultValues();
    }

    onMouseContainerLeaveFn(event) {
        event.stopPropagation();
        if (this.mousedown) {
            this.switchToSelected();
            this.selectedHours = this.updateSelectedHours();
            this.setTags(this.selectedHours);
            this.setDefaultValues();
        }
        this.showHover = false;
    }

    setDefaultValues() {
        this.mousedown = false;
        this.devarionMode = false;
        this.selectedDays = [];
        this.hoursMatrix = {
            startX: 0,
            stopX: 0,
            maxX: 0,
            minX: 0,
            startY: 0,
            stopY: 0,
            maxY: 0,
            minY: 0
        };
    }

    switchToSelected() {
        this.items.forEach(i => {
            i.hours.forEach(h => {
                if (h.preSelected) {
                    h.preSelected = false;
                    h.selected = !h.selected;
                }
            })
        });
    }

    setSelectedItems(newS, newE, newSpec, day) {
        this.items.forEach(item => {
            if (item.dayOfWeek !== day && angular.isDefined(newS)) return;
            item.hours.forEach(d => {
                d.selected = false;
                d.halfSelected = { start: false, end: false };
            });
            let tempHours, tempSelected = this.selectedHours.filter(h => h.dayOfWeek === item.dayOfWeek);
            for (let i = 0; i < tempSelected.length; i++) {
                let tl = tempSelected[i];
                let tx = tempSelected[i + 1];
                let tp = tempSelected[i - 1];
                if (tl.windowStartTime % 10 === 5 || tl.windowEndTime % 10 === 5) {
                    let tempH = item.hours.filter(i => (tl.windowStartTime - 15) === i.value || (tl.windowEndTime - 15) === i.value);
                    tempH.forEach(d => {
                        d.selected = true;
                        d.halfSelected = {
                            start: d.value + 15 === tl.windowEndTime && tl.windowEndTime % 10 === 5 ||
                                (angular.isDefined(tp) && tl.incrementalWindowSpecific !== tp.incrementalWindowSpecific && tl.windowStartTime - 15 >= tp.windowStartTime && (tl.windowStartTime === tp.windowEndTime || tl.windowStartTime + 15 <= tp.windowEndTime)),
                            end: d.value + 15 === tl.windowStartTime && tl.windowStartTime % 10 === 5 ||
                                (angular.isDefined(tx) && tl.incrementalWindowSpecific !== tx.incrementalWindowSpecific && (tl.windowEndTime === tx.windowStartTime || tl.windowEndTime - 15 >= tx.windowStartTime) && tl.windowEndTime + 15 <= tx.windowEndTime)
                        };
                        if (angular.isDefined(newS) && d.value >= newS && d.value < newE) {
                            d.incrementalWindowSpecific = newSpec;
                        } else {
                            if (d.halfSelected.start && d.halfSelected.end) {
                                d.incrementalWindowSpecific = tl.windowEndTime - tl.windowStartTime === 15 && angular.isDefined(tp) ? tp.incrementalWindowSpecific : tl.incrementalWindowSpecific;
                            } else {
                                d.incrementalWindowSpecific = tl.incrementalWindowSpecific;
                            }
                        }
                    });
                }
                tempHours = item.hours.filter(i => i.value >= tl.windowStartTime && i.value < tl.windowEndTime);
                tempHours.forEach(d => {
                    if (angular.isDefined(newS) && d.value >= newS && d.value < newE) {
                        d.incrementalWindowSpecific = newSpec;
                    } else {
                        d.incrementalWindowSpecific = tl.incrementalWindowSpecific;
                    }
                    d.selected = true;
                });
            }
        });
    }

    updateSelectedHours(tagTime) {
        let tempDayOfWeeks = this.selectedDays.map(i => i.dayOfWeek);
        this.counter = this.selectedHours.length;
        let output = this.selectedHours.filter(s => tempDayOfWeeks.indexOf(s.dayOfWeek) < 0);
        this.selectedDays.forEach(item => {
            let tempList = item.hours.filter(h => h.selected).map(i => { return { value: i.value, incrementalWindowSpecific: i.incrementalWindowSpecific, halfSelected: i.halfSelected } }),
                arrayOfHours = this.getArrayOfHours(tempList, tagTime);
            for (let i = 0; i < arrayOfHours.length; i++) {
                let p = arrayOfHours[i];
                let px = arrayOfHours[i + 1];
                let pp = arrayOfHours[i - 1];
                let out = {}, half;
                half = p.filter(i => i.halfSelected.start || i.halfSelected.end);
                if (half.length > 0) {
                    let acc;
                    for (let i = 0; i < p.length; i++) {
                        if (!p[i].halfSelected.start && !p[i].halfSelected.end) {
                            acc = 30;
                        }
                        if (p[i].halfSelected.start) {
                            acc = 15;
                        }
                        if (p[i].halfSelected.end) {
                            p[i].value = p[i].value + 15;
                            acc = 15;
                        }
                    }
                    if (p[0].halfSelected.start && p[0].halfSelected.end) {
                        p[0].incrementalWindowSpecific = !p[0].incrementalWindowSpecific;
                    }
                    out = { dayOfWeek: item.dayOfWeek, windowStartTime: _.min(p.map(a => a.value)), windowEndTime: _.max(p.map(a => a.value)) + acc, incrementalWindowSpecific: p[0].incrementalWindowSpecific };
                } else {
                    let pxh = 0;
                    if (angular.isDefined(px)) {
                        pxh = px.filter(i => i.halfSelected.start && i.halfSelected.end).length > 0 ? 15 : 0;
                    }
                    out = { dayOfWeek: item.dayOfWeek, windowStartTime: _.min(p.map(a => a.value)), windowEndTime: _.max(p.map(a => a.value)) + 30 + pxh, incrementalWindowSpecific: p[0].incrementalWindowSpecific };
                }
                output.push(out);
            }
        });
        return this.sortByDayOfWeek(output);
    }

    sortByDayOfWeek(data) {
        return data.sort((a, b) => {
            return a.dayOfWeek !== b.dayOfWeek ?
                this.daySorter[a.dayOfWeek.toUpperCase()] - this.daySorter[b.dayOfWeek.toUpperCase()] :
                a.windowStartTime - b.windowStartTime;
        });
    }

    clearSelectedHours(removeItem) {
        if (!removeItem) {
            //clear all
            this.selectedHours = [];
            this.items.forEach(item => {
                item.hours.forEach(hour => {
                    hour.selected = false;
                    hour.halfSelected.start = false;
                    hour.halfSelected.end = false;
                });
            });
            return;
        }
        this.selectedHours = this.selectedHours.filter(item => item.dayOfWeek !== removeItem.dayOfWeek || (item.dayOfWeek === removeItem.dayOfWeek && (item.windowEndTime < removeItem.windowStartTime || item.windowStartTime > removeItem.windowEndTime)));
        let tempItem = this.items.filter(item => item.dayOfWeek === removeItem.dayOfWeek)[0];
        let tempHours = tempItem.hours.filter(i => i.value >= removeItem.windowStartTime && i.value < removeItem.windowEndTime);
        if (removeItem.windowStartTime % 10 === 5 || removeItem.windowEndTime % 10 === 5) {
            let tempH = tempItem.hours.filter(i => (removeItem.windowStartTime - 15) === i.value || (removeItem.windowEndTime - 15) === i.value);
            tempH.forEach(d => {
                d.halfSelected.start = false;
                d.halfSelected.end = false;
                d.selected = false;
            })
        }
        tempHours.forEach(d => {
            d.selected = false;
            d.incrementalWindowSpecific = null;
        });
    }

    getArrayOfHours(hoursSelected, tagTime) {
        let innerCount = 0, arrayOfHours = [];
        for (let k = 1; k <= hoursSelected.length; k++) {
            let startEndCondition = undefined,
                prevCondition = false,
                bwCondition = true,
                current = hoursSelected[k],
                prev = hoursSelected[k - 1];
            if (angular.isDefined(current)) {
                prevCondition = current.value - prev.value !== 30;
                startEndCondition = prev.halfSelected.start || current.halfSelected.end || (current.halfSelected.end && prev.halfSelected.start);
                if (startEndCondition && (!current.halfSelected.start || !current.halfSelected.end)) {
                    if (angular.isDefined(tagTime) && prev.value >= tagTime.newS && current.value <= tagTime.newE) {
                        startEndCondition = false;
                        prev.halfSelected.start = false;
                        prev.halfSelected.end = false;
                        current.halfSelected.start = false;
                        current.halfSelected.end = false;
                    }
                }
                bwCondition = current.incrementalWindowSpecific !== prev.incrementalWindowSpecific;
                if (bwCondition && prev.halfSelected.start && prev.halfSelected.end) {
                    bwCondition = false;
                    startEndCondition = false;
                }
            }
            if (prevCondition || startEndCondition || bwCondition) {
                arrayOfHours.push(_.slice(hoursSelected, innerCount, k));
                innerCount = k;
            }
        }
        arrayOfHours = arrayOfHours === [] ? arrayOfHours.push(hoursSelected) : arrayOfHours;
        return arrayOfHours;
    }

    /** START: TAG SELECTOR */
    setTags(selectedHours) {
        this.displayedTags = [];
        this.tags = [];
        selectedHours.forEach(item => {
            this.tags.push({
                dayOfWeek: item.dayOfWeek,
                windowStartTime: item.windowStartTime,
                windowEndTime: item.windowEndTime,
                customValue: setTagString(item),
                type: item.incrementalWindowSpecific ? 'INCR' : 'FULL_INCR',
                additionalText: item.dayOfWeek,
                label: this.days.filter(day => day.value === item.dayOfWeek)[0].label
            });
        });
        function setTagString(item) {
            return [{
                hours: (item.windowStartTime < 600 ? '0' : '') + Math.floor(item.windowStartTime / 60),
                minutes: item.windowStartTime % 10 === 5 ? ((item.windowStartTime - 15) / 60) % 1 !== 0 ? '45' : '15' : (item.windowStartTime / 60) % 1 !== 0 ? '30' : '00',
                start: true
            }, {
                hours: (item.windowEndTime < 600 ? '0' : '') + Math.floor(item.windowEndTime / 60),
                minutes: item.windowEndTime % 10 === 5 ? ((item.windowEndTime - 15) / 60) % 1 !== 0 ? '45' : '15' : (item.windowEndTime / 60) % 1 !== 0 ? '30' : '00',
                start: false
            }]
        }
        this.setTagsPagination();
    }

    tagChanged(tag) {
        let newStartTime = convertToValue(tag.customValue.filter(cv => cv.start)[0]),
            newEndTime = convertToValue(tag.customValue.filter(cv => !cv.start)[0]),
            shouldReverse = newStartTime > newEndTime,
            newWindowSpecific = tag.type === 'INCR';
        if (shouldReverse) {
            tag.customValue.reverse();
            tag.customValue.forEach(cv => cv.start = !cv.start);
            [newStartTime, newEndTime] = [newEndTime, newStartTime];
        }
        for (let i = 0; i < this.selectedHours.length; i++) {
            let sh = this.selectedHours[i];
            if (sh.dayOfWeek === tag.dayOfWeek && sh.windowStartTime === tag.windowStartTime && sh.windowEndTime === tag.windowEndTime) {
                sh.windowStartTime = newStartTime;
                sh.windowEndTime = newEndTime;
                sh.incrementalWindowSpecific = newWindowSpecific;
            }
        }
        this.selectedDays.push(this.items.filter(item => item.dayOfWeek === tag.dayOfWeek)[0]);
        this.setSelectedItems(newStartTime, newEndTime, newWindowSpecific, tag.dayOfWeek);
        this.selectedHours = this.updateSelectedHours({ newS: newStartTime, newE: newEndTime });
        this.setTags(this.selectedHours, tag);
        this.setDefaultValues();
        function convertToValue(st) {
            return Number(st.hours) * 60 + Number(st.minutes);
        }
    }

    setTagsPagination() {
        if (this.tags.length === 0) {
            this.tagsPagination = { currentPage: 1, totalPages: 1 };
            this.displayedTags = [];
        } else {
            this.tagsPagination.totalPages = Math.ceil(this.tags.length / 15);
            if (this.tagsPagination.totalPages < this.tagsPagination.currentPage) {
                this.tagsPagination.currentPage = this.tagsPagination.totalPages;
            }
            let start = (this.tagsPagination.currentPage - 1) * 15;
            let end = start + 15;
            this.displayedTags = this.tags.slice(start, end);
        }
    }

    scrollTagPage(i) {
        this.tagsPagination.currentPage = this.tagsPagination.currentPage + i;
        this.setTagsPagination();
    }

    tagRemove(tag) {
        this.tags = this.tags.filter(item => item !== tag);
        this.setTagsPagination();
        this.clearSelectedHours(tag);
    }

    removeAllTags() {
        this.tags.forEach(tag => this.tagRemove(tag, false));
        this.slidePosition = { index: 0, offset: 0 };
        this.tagsPagination = { currentPage: 1, totalPages: 1 };
        //clear all selected hours
        this.clearSelectedHours();
    }
    /** END: TAG SELECTOR */

    getBaseHours(base) {
        let hour = (!base || base.start >= base.end || base.start < 0 || base.end > 24) ? { start: 0, end: 1440 } : base,
            output = [],
            startHour = hour.start,
            endHour = hour.end - 30,
            curHour = startHour;
        let incr = 0;
        for (curHour; curHour <= endHour; curHour = curHour + 30) {
            incr++;
            output.push({ label: incr % 2 !== 0 ? ((curHour < 600) ? ('0' + (curHour / 60).toString()) : (curHour / 60).toString()) : '', value: curHour });
        }
        this.lastHour = { label: '24', value: 1440 };
        return output;
    }

    parseHours(base) {
        let string = base || "1:00AM-12:00PM";
        let output = [],
            split = string.toUpperCase().split("-"),
            startInt = parseInt(split[0].split(":")[0]),
            endInt = parseInt(split[1].split(":")[0]),
            startHour = split[0].indexOf("PM") !== -1 ? startInt + 12 : startInt,
            endHour = split[1].indexOf("PM") !== -1 ? endInt + 12 : endInt,
            curHour = startHour;

        for (curHour; curHour <= endHour; curHour++) {
            let parsedStr = "", value;
            if (curHour > 12) {
                value = curHour - 12;
                parsedStr += (curHour - 12).toString() + " PM";
            }
            else if (curHour == 12) {
                value = curHour;
                parsedStr += curHour.toString() + " PM";
            }
            else {
                value = curHour;
                parsedStr += curHour.toString() + " AM";
            }
            output.push({ label: parsedStr, value: curHour });
        }
        return output;
    }

    toggleWholeDay(day) {
        let dayItem;
        this.items.forEach(item => {
            if (item.label === day.label) {
                dayItem = item;
            }
        });
        if (dayItem.hours.every(hour => hour.selected)) {
            dayItem.hours.forEach(hour => {
                hour.selected = false;
                hour.halfSelected.start = false;
                hour.halfSelected.end = false;
                this.setFullBw(hour);
            });
        } else {
            dayItem.hours.forEach(hour => {
                hour.selected = true;
                hour.halfSelected.start = false;
                hour.halfSelected.end = false;
                this.setFullBw(hour);
            });
        }

        this.selectedDays.push(dayItem);
        this.selectedHours = this.updateSelectedHours();
        this.setTags(this.selectedHours);
        this.selectedDays = [];
    }

    toggleWholeHour(hour) {
        if (this.items.every(item => item.hours[hour / 30].selected)) {
            this.items.forEach(item => {
                item.hours[hour / 30].selected = false;
                item.hours[hour / 30 + 1].selected = false;
                item.hours[hour / 30].halfSelected.start = false;
                item.hours[hour / 30].halfSelected.end = false;
                item.hours[hour / 30 + 1].halfSelected.start = false;
                item.hours[hour / 30 + 1].halfSelected.end = false;
                this.setFullBw(item.hours[hour / 30]);
                this.setFullBw(item.hours[hour / 30 + 1]);
            });
        } else {
            this.items.forEach(item => {
                item.hours[hour / 30].selected = true;
                item.hours[hour / 30 + 1].selected = true;
                item.hours[hour / 30].halfSelected.start = false;
                item.hours[hour / 30].halfSelected.end = false;
                item.hours[hour / 30 + 1].halfSelected.start = false;
                item.hours[hour / 30 + 1].halfSelected.end = false;
                this.setFullBw(item.hours[hour / 30]);
                this.setFullBw(item.hours[hour / 30 + 1]);
            });
        }
        this.selectedDays = this.items.slice();
        this.selectedHours = this.updateSelectedHours();
        this.setTags(this.selectedHours);
        this.selectedDays = [];
    }

    setSelectedClass(hour) {
        //     if (angular.isDefined(hour.incrementalWindowSpecific) && hour.incrementalWindowSpecific) {
        //         return {
        //             'selected-incr': hour.selected,
        //             'pre-selected-incr': hour.preSelected,
        //             'half-selected-start-incr': hour.halfSelected.start,
        //             'half-selected-end-incr': hour.halfSelected.end,
        //             'whole-selected-incr-full-incr': hour.halfSelected.start && hour.halfSelected.end
        //         }
        //     }
        // if (angular.isDefined(hour.incrementalWindowSpecific) && hour.incrementalWindowSpecific === false) {
        return {
            'selected-full-incr': hour.selected,
            'pre-selected-full-incr': hour.preSelected,
            'half-selected-start-full-incr': hour.halfSelected.start,
            'half-selected-end-full-incr': hour.halfSelected.end,
            'whole-selected-full-incr-incr': hour.halfSelected.start && hour.halfSelected.end
            // };
        }
    }

    setBetweenClass(item, index) {
        // if (angular.isDefined(item.hours[index].incrementalWindowSpecific) && item.hours[index].incrementalWindowSpecific) {
        //     return {
        //         'background-color': item.hours[index].selected && angular.isDefined(item.hours[index + 1]) && item.hours[index + 1].selected &&
        //             item.hours[index].incrementalWindowSpecific === item.hours[index + 1].incrementalWindowSpecific ? '#1FAEB8' :
        //             item.hours[index].preSelected && angular.isDefined(item.hours[index + 1]) && item.hours[index + 1].preSelected ? '#33c4ce' : ''
        //     }
        // }
        // if (angular.isDefined(item.hours[index].incrementalWindowSpecific) && item.hours[index].incrementalWindowSpecific === false) {
        return {
            'background-color': item.hours[index].selected && angular.isDefined(item.hours[index + 1]) && item.hours[index + 1].selected &&
                item.hours[index].incrementalWindowSpecific === item.hours[index + 1].incrementalWindowSpecific ? '#2E75D2' :
                item.hours[index].preSelected && angular.isDefined(item.hours[index + 1]) && item.hours[index + 1].preSelected ? '#558aec' : ''
        }
        // }
    }

    calculateLinesOnHover(event, hour, item) {
        /* Calculate lines on hover */
        event.stopPropagation();
        let values = {};
        if (!this.mousedown) {
            if (!hour.selected) {
                values = {
                    lineLeftX: event.currentTarget.offsetLeft - 2,
                    lineRightX: event.currentTarget.offsetLeft - 2 + 20,
                    lineLeftY: !hour.label ? 7 : 0,
                    lineRightY: !hour.label ? 0 : 7,
                    lineLeftHeight: !hour.label ? 16 : 23,
                    lineRightHeight: !hour.label ? 23 : 16,
                    indexCurrentDay: this.days.map((day) => day.value).indexOf(item.dayOfWeek)
                };
            } else {
                let addition = hour.halfSelected.end ? 15 : 0,
                    currentSelection = this.selectedHours.filter(sh => sh.dayOfWeek === item.dayOfWeek && (hour.value + addition >= sh.windowStartTime && hour.value <= sh.windowEndTime)),
                    hoverItem = currentSelection.length === 0 ? null : currentSelection.length > 1 ? currentSelection[1] : currentSelection[0],
                    start = hoverItem.windowStartTime / 30,
                    end = hoverItem.windowEndTime / 30;
                values = {
                    lineLeftX: start * 20,
                    lineRightX: end * 20,
                    lineLeftY: start % 2 === 0 ? 0 : 7,
                    lineRightY: end % 2 === 0 ? 0 : 7,
                    lineLeftHeight: start % 2 === 0 ? 23 : 16,
                    lineRightHeight: end % 2 === 0 ? 23 : 16,
                    indexCurrentDay: this.days.map((day) => day.value).indexOf(item.dayOfWeek)
                };

            }
            this.setLines(values);
        }
        this.showHover = true;
    }

    calculateLinesOnDragg() {
        /* Calculate lines on dragging */
        let startX = this.hoursMatrix.startX,
            stopX = this.hoursMatrix.stopX,
            goingLeft = startX > stopX,
            values = {};
        if (goingLeft) {
            values = {
                lineLeftX: ((startX + 30) / 30) * 20,
                lineRightX: (stopX / 30) * 20,
                lineLeftY: (startX / 30) % 2 === 0 ? 7 : 0,
                lineRightY: (stopX / 30) % 2 === 0 ? 0 : 7,
                lineLeftHeight: (startX / 30) % 2 === 0 ? 16 : 23,
                lineRightHeight: (stopX / 30) % 2 === 0 ? 23 : 16,
                indexCurrentDay: this.hoursMatrix.stopY
            }
        } else {
            values = {
                lineLeftX: (startX / 30) * 20,
                lineRightX: ((stopX + 30) / 30) * 20,
                lineLeftY: (startX / 30) % 2 === 0 ? 0 : 7,
                lineRightY: (stopX / 30) % 2 === 0 ? 7 : 0,
                lineLeftHeight: (startX / 30) % 2 === 0 ? 23 : 16,
                lineRightHeight: (stopX / 30) % 2 === 0 ? 16 : 23,
                indexCurrentDay: this.hoursMatrix.stopY
            }
        }
        this.setLines(values);
    }

    setLines(values) {
        /*Set positions of lines and height of lines*/
        let rightHorizontal = this.$element.find('.right-horizontal-line'),
            leftHorizontal = this.$element.find('.left-horizontal-line'),
            hoverContainer = this.$element.find('.hover-element');

        leftHorizontal.css('transform', `translate(${values.lineLeftX}px, ${values.lineLeftY}px)`);
        rightHorizontal.css('transform', `translate(${values.lineRightX}px, ${values.lineRightY}px)`);

        leftHorizontal.css('height', (values.indexCurrentDay + 1) * 38 + values.lineLeftHeight);
        rightHorizontal.css('height', (values.indexCurrentDay + 1) * 38 + values.lineRightHeight);

        hoverContainer.css('transform', `translate(-54px, ${values.indexCurrentDay * 38}px)`);
    }

    setBackupType(backupType) {
        this.backupType = backupType;
    }
}

ctxWeeklySchedulerController.$inject = ['$scope', '$element', '$timeout', '$attrs', '$filter', 'utilsService', 'dialogService'];

const ctxWeeklySchedulerComponent = {
    controller: ctxWeeklySchedulerController,
    require: ['ngModel'],
    scope: {},
    template: require('./ctxWeeklyScheduler.template.html'),
    bindings: {
        selectedHours: '=?ngModel',
        inputLabel: '@?',
        days: '=?',
        hours: '=?',
        haveTagSelector: '<?',
        tzDiff: '<?',
        tzChanged: '<?'
    }
};

module.exports = ctxWeeklySchedulerComponent;


// WEBPACK FOOTER //
// ./src/shared/ctxWeeklyScheduler/ctxWeeklyScheduler.component.js